import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const NAV = [
  { path: '/admin', label: 'Dashboard', icon: '📊' },
  { path: '/admin/services', label: 'Services', icon: '🛠' },
  { path: '/admin/case-studies', label: 'Case Studies', icon: '📁' },
  { path: '/admin/news', label: 'News & Insights', icon: '📰' },
  { path: '/admin/press-references', label: 'Press References', icon: '🔗' },
  { path: '/admin/team', label: 'Team', icon: '👥' },
  { path: '/admin/careers', label: 'Careers', icon: '💼' },
  { path: '/admin/contacts', label: 'Contacts', icon: '✉️' },
];

const AdminLayout = ({ children }) => {
  const { admin, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', fontFamily: 'system-ui, sans-serif', background: '#f8fafc' }}>
      {/* Sidebar */}
      <aside style={{
        width: sidebarOpen ? '240px' : '60px',
        background: '#0f172a',
        color: '#e2e8f0',
        display: 'flex',
        flexDirection: 'column',
        transition: 'width 0.2s',
        flexShrink: 0,
        overflowX: 'hidden'
      }}>
        {/* Logo */}
        <div style={{ padding: '20px 16px', borderBottom: '1px solid #1e293b', display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span style={{ fontSize: '20px', flexShrink: 0 }}>⚡</span>
          {sidebarOpen && <span style={{ fontWeight: 700, fontSize: '14px', color: '#64b5f6', whiteSpace: 'nowrap' }}>InfiniNova Admin</span>}
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, padding: '12px 0' }}>
          {NAV.map(item => {
            const active = location.pathname === item.path ||
              (item.path !== '/admin' && location.pathname.startsWith(item.path));
            return (
              <Link key={item.path} to={item.path} style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '10px 16px',
                color: active ? '#64b5f6' : '#94a3b8',
                background: active ? 'rgba(100, 181, 246, 0.1)' : 'transparent',
                textDecoration: 'none',
                borderLeft: active ? '3px solid #64b5f6' : '3px solid transparent',
                fontSize: '13px',
                fontWeight: active ? 600 : 400,
                whiteSpace: 'nowrap',
                transition: 'all 0.15s'
              }}>
                <span style={{ fontSize: '16px', flexShrink: 0 }}>{item.icon}</span>
                {sidebarOpen && item.label}
              </Link>
            );
          })}
        </nav>

        {/* User */}
        <div style={{ padding: '12px 16px', borderTop: '1px solid #1e293b' }}>
          {sidebarOpen && (
            <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '8px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {admin?.displayName || admin?.username}
            </div>
          )}
          <button onClick={handleLogout} style={{
            background: '#1e293b',
            color: '#94a3b8',
            border: 'none',
            borderRadius: '6px',
            padding: '8px',
            cursor: 'pointer',
            fontSize: '12px',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            justifyContent: sidebarOpen ? 'flex-start' : 'center'
          }}>
            <span>🚪</span>{sidebarOpen && 'Logout'}
          </button>
        </div>
      </aside>

      {/* Main content */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        {/* Top bar */}
        <header style={{
          background: '#fff',
          borderBottom: '1px solid #e2e8f0',
          padding: '0 24px',
          height: '56px',
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          flexShrink: 0
        }}>
          <button onClick={() => setSidebarOpen(o => !o)} style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '18px',
            color: '#64748b'
          }}>☰</button>
          <div style={{ flex: 1 }} />
          <a href="/" target="_blank" rel="noreferrer" style={{ color: '#64748b', fontSize: '13px', textDecoration: 'none' }}>
            ← View Site
          </a>
        </header>

        {/* Page content */}
        <main style={{ flex: 1, overflow: 'auto', padding: '24px' }}>
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
